import "./Header.css";
import { useIsMobile } from "src/hooks/useIsMobile";
import arrow from "../../images/arrow.svg";
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";
interface HeaderProps {
  toggleMenu: () => void;
  isMenuOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ toggleMenu, isMenuOpen }) => {
  const { isMobile } = useIsMobile();

  return (
    <header className="header-container">
      <div className="header-top">
        <Link
          to="/certificate-authentication"
          className="header-link header-link-auth"
        >
          Certificate Authentication
          <ReactSVG src={arrow} />
        </Link>
        <Link to="/applications/add" className="header-link header-link-app">
          Application
          <ReactSVG src={arrow} />
        </Link>
      </div>
      {isMobile && (
        <button
          onClick={toggleMenu}
          className={`header-mobile-button ${isMenuOpen ? "active" : ""}`}
        >
          <div className={`div-style ${isMenuOpen ? "active" : ""}`}></div>
          <div className={`div-style ${isMenuOpen ? "active" : ""}`}></div>
        </button>
      )}
    </header>
  );
};

export default Header;
